import Cookie, { CANCELED_SESSION_EXPIRED } from '~/common/cookie';
import { snakeCase } from 'lodash';
import moment from 'moment';

export const logoutWithRedirectBack = () => {
  if (window) {
    Cookie.remove('__naluri__');
    Cookie.remove(CANCELED_SESSION_EXPIRED);
    let encodedCurrentURL = encodeURIComponent(window.location.href);
    window.location.href = `/session/login?sessionTimeout=true&redirect_back=${encodedCurrentURL}`;
  }
};

export const delay = (() => {
  let timer = 0;
  return (callback, ms) => {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export const getApiHost = () => {
  if (process.env.NALURI_APP_ENV === 'production') {
    return process.env.NALURI_APP_API_HOST;
  } else {
    return Cookie.get('__NALURI_ENV__') || process.env.NALURI_APP_API_HOST;
  }
};

export const getClearXPApiHost = () => {
  return process.env.NALURI_APP_CLEARXP_API_BASE_URL;
};

export const getAggregatorApiHost = () => {
  return process.env.NALURI_APP_AGGREGATOR_API_HOST;
};

export const getCoeusApiHost = () => {
  return process.env.NALURI_APP_COEUS_API_HOST;
};

export const getCoachPlatformApiHost = () => {
  return process.env.NALURI_APP_COACH_PLATFORM_API_BASE_URL;
};

export const setEnvironment = () => {
  if (Cookie.get('__NALURI_ENV__') == null) {
    if (process.env.NALURI_APP_ENV === 'production') {
      Cookie.set('__NALURI_ENV__', process.env.NALURI_APP_API_HOST, { path: '/' });
    } else {
      Cookie.set('__NALURI_ENV__', process.env.NALURI_APP_API_HOST, { path: '/' }) ||
        Cookie.set('__NALURI_ENV__', 'staging.naluri.net', { path: '/' });
    }
  }
};

export const getAppSecure = types => {
  let NALURI_ENV_URL_STATUS = Cookie.get('__NALURI_ENV__')
    ? Cookie.get('__NALURI_ENV__').includes('localhost')
      ? true
      : false
    : false;
  let NALURI_SECURE = null;
  if (process.env.NALURI_APP_SECURE === 'true') {
    if (NALURI_ENV_URL_STATUS) {
      NALURI_SECURE = types === 'websocket' ? 'ws://' : 'http://';
    } else {
      NALURI_SECURE = types === 'websocket' ? 'wss://' : 'https://';
    }
  } else {
    if (NALURI_ENV_URL_STATUS) {
      NALURI_SECURE = types === 'websocket' ? 'ws://' : 'http://';
    } else {
      NALURI_SECURE = types === 'websocket' ? 'wss://' : 'https://';
    }
  }
  return NALURI_SECURE;
};

export const getAppSecureGraphQL = types => {
  let NALURI_ENV_URL_STATUS = window.location.href.includes('localhost') ? true : false;
  let NALURI_SECURE = null;
  if (process.env.NALURI_APP_SECURE === 'true') {
    NALURI_SECURE = types === 'websocket' ? 'wss://' : 'https://';
  } else {
    if (NALURI_ENV_URL_STATUS) {
      NALURI_SECURE = types === 'websocket' ? 'ws://' : 'http://';
    } else {
      NALURI_SECURE = types === 'websocket' ? 'wss://' : 'https://';
    }
  }
  return NALURI_SECURE;
};

export const hasKeys = obj => {
  if (Object.getOwnPropertyNames(obj).length < 1) {
    return false;
  } else {
    return true;
  }
};

export function isEmpty(obj) {
  if (obj) {
    return Object.keys(obj).length === 0;
  } else {
    return true;
  }
}

export const notInfinityNull = data => {
  return !isFinite(data) || data !== null;
};

export const notNan = data => {
  return !isNaN(data) && isFinite(data) && data !== null;
};

export const updateArrayCholesterolRatio = data => {
  if (!notNan(data)) {
    return 'N/A';
  } else if (data >= 5) {
    return 'Bad';
  } else {
    return 'Good';
  }
};

export const getNumberOfFiltersAppliedSidebar = (defaultParams, currentParams) => {
  let noOfFilters = 0;
  let filtersChosen = {};

  for (var key in defaultParams) {
    if (key !== 'sortOrder') {
      if (key === 'sponsors' || key === 'emotionalScores' || key === 'physicalScores') {
        if (defaultParams[key].length !== currentParams[key].length) {
          filtersChosen = { ...filtersChosen, [snakeCase(key)]: currentParams[key] };
          noOfFilters++;
        }
      } else if (defaultParams[key] !== currentParams[key]) {
        if (key === 'language') {
          filtersChosen = { ...filtersChosen, locale: currentParams[key] };
        } else {
          filtersChosen = { ...filtersChosen, [snakeCase(key)]: currentParams[key] };
        }
        noOfFilters++;
      }
    }
  }

  return {
    count: noOfFilters,
    filtersChosen,
  };
};

export const getBPStatus = (systolic, diastolic) => {
  if ((systolic >= 140 && diastolic < 90) || systolic >= 140 || diastolic >= 90) {
    return 'High';
  }

  if (systolic >= 130 || diastolic >= 85) {
    return 'At Risk';
  }

  if (systolic >= 90 || diastolic >= 60) {
    return 'Normal';
  }

  if (systolic < 90 || diastolic < 60) {
    return 'Low';
  }
};

export const getBPStatusColor = [
  {
    label: 'High',
    color: '#E11C4C',
  },
  {
    label: 'At Risk',
    color: '#DEA600',
  },
  {
    label: 'Normal',
    color: '#1B837C',
  },
  {
    label: 'Optimal',
    color: '#1B837C',
  },
  {
    label: 'Low',
    color: '#E11C4C',
  },
];

export const testPhysicalLabel = testResult => {
  if (testResult == null) {
    return 'rgba(255, 255, 255, 0.9)';
  } else {
    const resultParts = testResult.split('-');
    const level = resultParts[1] ? resultParts[1].trim() : resultParts[0];

    if (level === 'Low') {
      return '#c7c7c7';
    } else if (level === 'Normal' || level === 'Good') {
      return '#b7eb8f';
    } else if (level === 'High' || level === 'Poor' || level === 'Pre' || level === 'At Risk') {
      return '#ffe58f';
    } else if (
      level === 'Very High' ||
      level === 'Very Poor' ||
      level === 'Hypertensive' ||
      level === 'Diabetic' ||
      level === 'Bad'
    ) {
      return '#ffa39e';
    } else if (level === 'N/A') {
      return '#ADD8E6';
    }
  }
};

export const formatDate = date => {
  return moment
    .utc(date)
    .local()
    .format('DD.MM.YYYY');
};

export const getTotalCholesterolLevel = totalCholesterol => {
  if (!notInfinityNull(totalCholesterol)) {
    return 'N/A';
  }
  if (totalCholesterol >= 2.0 && totalCholesterol <= 3.0) {
    return 'Low';
  } else if (totalCholesterol >= 3.1 && totalCholesterol <= 5.1) {
    return 'Normal';
  } else if (totalCholesterol >= 5.2 && totalCholesterol <= 6.1) {
    return 'High';
  } else if (totalCholesterol >= 6.2 && totalCholesterol <= 9.9) {
    return 'Very High';
  } else {
    return 'None';
  }
};

export const getLdlCholesterolLevel = ldlCholesterol => {
  if (!notInfinityNull(ldlCholesterol)) {
    return 'N/A';
  }
  if (ldlCholesterol >= 0 && ldlCholesterol <= 0.9) {
    return 'Low';
  } else if (ldlCholesterol >= 1.0 && ldlCholesterol <= 2.58) {
    return 'Normal';
  } else if (ldlCholesterol >= 2.59 && ldlCholesterol <= 3.59) {
    return 'High';
  } else if (ldlCholesterol >= 3.6 && ldlCholesterol <= 6.0) {
    return 'Very High';
  } else {
    return 'None';
  }
};

export const getHdlCholesterolLevel = hdlCholesterol => {
  if (!notInfinityNull(hdlCholesterol)) {
    return 'N/A';
  }
  if (hdlCholesterol >= 1.03 && hdlCholesterol <= 6.0) {
    return 'Normal';
  } else if (hdlCholesterol >= 0.8 && hdlCholesterol <= 1.02) {
    return 'Poor';
  } else if (hdlCholesterol >= 0 && hdlCholesterol <= 0.79) {
    return 'Very Poor';
  } else {
    return 'None';
  }
};

export const getTriglycerideLevel = triglyceride => {
  if (!notInfinityNull(triglyceride)) {
    return 'N/A';
  }
  if (triglyceride >= 0 && triglyceride <= 0.4) {
    return 'Low';
  } else if (triglyceride >= 0.5 && triglyceride <= 1.69) {
    return 'Normal';
  } else if (triglyceride >= 1.7 && triglyceride <= 2.69) {
    return 'High';
  } else if (triglyceride >= 2.7 && triglyceride <= 6.0) {
    return 'Very High';
  } else {
    return 'None';
  }
};

export const getHba1cLevel = hba1c => {
  if (!notInfinityNull(hba1c)) {
    return 'N/A';
  }
  if (hba1c >= 2.0 && hba1c <= 3.9) {
    return 'Low';
  } else if (hba1c >= 4.0 && hba1c <= 5.6) {
    return 'Normal';
  } else if (hba1c >= 5.7 && hba1c <= 6.4) {
    return 'Pre-Diabetic';
  } else if (hba1c >= 6.5 && hba1c <= 15) {
    return 'Diabetic';
  } else {
    return 'None';
  }
};

export const getSystolicLevel = systolic => {
  if (!notInfinityNull(systolic)) {
    return 'N/A';
  }
  if (systolic >= 60 && systolic <= 89) {
    return 'Low';
  } else if (systolic >= 90 && systolic <= 119) {
    return 'Normal';
  } else if (systolic >= 120 && systolic <= 139) {
    return 'At Risk';
  } else if (systolic >= 140 && systolic <= 200) {
    return 'Hypertensive';
  } else {
    return 'None';
  }
};

export const getDiastolicLevel = diastolic => {
  if (!notInfinityNull(diastolic)) {
    return 'N/A';
  }
  if (diastolic >= 30 && diastolic <= 59) {
    return 'Low';
  } else if (diastolic >= 60 && diastolic <= 79) {
    return 'Normal';
  } else if (diastolic >= 80 && diastolic <= 89) {
    return 'At Risk';
  } else if (diastolic >= 90 && diastolic <= 140) {
    return 'Hypertensive';
  } else {
    return 'None';
  }
};

export const getDefaultHealthDataUOM = fieldName => {
  // Function to retrieve a health data point's default unit of measurement
  // Supports fields: bmi, weight, height, bp_systollic, bp_diastollic, waistline, hba1c, hba1c_ifcc, cholesterol_total, cholesterol_ldl, cholesterol_hdl, cholesterol_triglycerides, cholesterol_non_hdl
  // This function is used for displaying members' profile's BT health data under the `Health Data (Investigation)` section

  const healthFieldToUOM = {
    bmi: 'kg/m^2',
    weight: 'kg',
    height: 'cm',
    bp_systollic: 'mmHg',
    bp_diastolic: 'mmHg',
    waistline: 'inch',
    hba1c: '%',
    hba1c_ifcc: '%',
    cholesterol_total: 'mmol/L',
    cholesterol_ldl: 'mmol/L',
    cholesterol_hdl: 'mmol/L',
    cholesterol_triglycerides: 'mmol/L',
    cholesterol_non_hdl: 'mmol/L',
  };
  return Object.keys(healthFieldToUOM).includes(fieldName) ? `${healthFieldToUOM[fieldName]}` : '';
};

// Used to create ticks for rechart timeseries charts.
// TODO : Generalise this function to handle different types of time intervals.
export const getTicks = (startDateStr, endDateStr) => {
  const startDate = moment(startDateStr);
  const endDate = moment(endDateStr);
  const diff = endDate.diff(startDate, 'days');

  const ticks = [];
  for (let i = 1; i <= diff + 1; i++) {
    const tick = startDate.local().format('MMM Do');
    ticks.push(tick);
    startDate.add(1, 'day');
  }
  return ticks;
};

// Used to fill data object with tick data. Useful for time series data with missing time values
// TODO: Generalise this method so it can handle different types of fields.
// So it can be reused for blood sugar, steps etc visualisations
export const fillTicksData = (_ticks, data) => {
  const ticks = [..._ticks];
  const filled = [];

  for (const tick of ticks) {
    if (data[tick]) {
      filled.push(data[tick]);
    } else {
      filled.push({
        name: tick,
        meals: [],
        dailyCarbs: 0,
        dailyEnergy: 0,
        dailyProtein: 0,
        dailyFibre: 0,
        dailyTotalFat: 0,
        dailySodium: 0,
      });
    }
  }

  return filled;
};

// Used to aggregate food journals by date. Maybe can be generalised to groupby other timescales (week, month, etc)
// This aggregation can also be moved to naluri-health when FJ is moved to naluri-health DB
export const getDailyTotals = (journals, journalTotals, nutritionFields) => {
  const dailyTotals = {};

  journals.toJS().forEach(foodJournal => {
    const foodJournalDate = moment
      .utc(foodJournal.eaten_at)
      .local()
      .format('MMM Do');

    const foodJournalTotals = journalTotals.find(f => f.foodJournalId === foodJournal.id);

    if (foodJournalTotals) {
      if (!dailyTotals[foodJournalDate]) {
        dailyTotals[foodJournalDate] = {};
        dailyTotals[foodJournalDate]['name'] = foodJournalDate;
        dailyTotals[foodJournalDate]['meals'] = [];

        nutritionFields.forEach(field => {
          const journalTotalsString = 'journal'.concat(capitalize(field));
          const dailyTotalsString = 'daily'.concat(capitalize(field));
          dailyTotals[foodJournalDate][dailyTotalsString] = foodJournalTotals[journalTotalsString];
        });
      } else {
        nutritionFields.forEach(field => {
          const journalTotalsString = 'journal'.concat(capitalize(field));
          const dailyTotalsString = 'daily'.concat(capitalize(field));
          dailyTotals[foodJournalDate][dailyTotalsString] += foodJournalTotals[journalTotalsString];
        });
      }

      const meal = {};
      nutritionFields.forEach(field => {
        const journalTotalsString = 'journal'.concat(capitalize(field));
        meal[journalTotalsString] = foodJournalTotals[journalTotalsString];
      });

      meal.mealName = foodJournal.meal_time;
      meal.rating = foodJournal.meal_review;
      dailyTotals[foodJournalDate]['meals'].push(meal);
    }
  });
  return dailyTotals;
};

export const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.toString().slice(1);
};

export const time_convert = num => {
  const days = Math.floor(num / (3600 * 24));
  const hours = Math.floor((num % (3600 * 24)) / 3600);
  const minutes = Math.floor((num % 3600) / 60);
  const seconds = Math.floor(num % 60);

  if (days > 0) {
    return days + ' day(s) ago';
  }
  if (hours > 0) {
    return hours + ' hour(s) ' + minutes + ' mins ago';
  }
  if (minutes <= 0) {
    return seconds + ' second(s) ago';
  } else {
    return minutes + ' min(s) ago';
  }
};

export const fetchLastMessageTimestamp = lastMessageTimestamp => {
  const diffInMins = moment
    .utc()
    .local()
    .diff(moment.utc(lastMessageTimestamp).local(), 'seconds');
  return time_convert(diffInMins);
};

export const legendUserMetabase = () => {
  return [
    {
      status: 'Never tried',
      color: 'transparent',
      tooltip: 'User has never done the activity before.',
    },
    {
      status: 'First time',
      color: 'rgba(136, 191, 77, 0.65)',
      tooltip: 'User has done the activity for the first time this week.',
    },
    {
      status: 'Maintained',
      color: 'rgba(80, 158, 227, 0.65)',
      tooltip: 'User has the same number of activities this week compared to last week..',
    },
    {
      status: 'Increased',
      color: 'rgba(136, 191, 77, 0.65)',
      tooltip: 'User has increased in the number of activities this week compared to last week.',
    },
    {
      status: 'Decreased',
      color: 'rgba(169, 137, 197, 0.65)',
      tooltip: 'User has decreased in the number of activities this week compared to last week.',
    },
    {
      status: 'Reactivated',
      color: 'rgba(136, 191, 77, 0.65)',
      tooltip:
        'User has done the activity this week after no activities since at least the week before last week.',
    },
    {
      status: 'None since at least two weeks ago',
      color: 'rgba(239, 140, 140, 0.65)',
      tooltip: 'User had no activities since at least the week before last week.',
    },
  ];
};

export const legendModuleRecomMetabase = () => {
  return [
    {
      status: 'Below the target',
      color: 'rgba(239, 140, 140, 0.65)',
      tooltip:
        'Targets are defined by average activities of Naluri users with the best BMI results.',
    },
  ];
};

export const generateTimeTicks = () => {
  const hours = [];
  [...Array(24)].forEach((_, i) => hours.push(moment(i, 'hh:mm').format('h:mm A')));
  return hours;
};

export const getLocales = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Bahasa Melayu',
    value: 'bm',
  },
  {
    label: '中文',
    value: 'zh',
  },
  {
    label: 'Bahasa Indonesia',
    value: 'id',
  },
  {
    label: 'ไทย',
    value: 'th',
  },
  {
    label: 'All Languages',
    value: 'all',
  },
];

export const getCountries = [
  {
    code: 'all',
    name: 'All Countries',
  },
  {
    code: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'SG',
    name: 'Singapore',
  },
  {
    code: 'ID',
    name: 'Indonesia',
  },
  {
    code: 'TH',
    name: 'Thailand',
  },
  {
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    code: 'AX',
    name: 'Åland Islands',
  },
  {
    code: 'AL',
    name: 'Albania',
  },
  {
    code: 'DZ',
    name: 'Algeria',
  },
  {
    code: 'AS',
    name: 'American Samoa',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'AI',
    name: 'Anguilla',
  },
  {
    code: 'AQ',
    name: 'Antarctica',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AR',
    name: 'Argentina',
  },
  {
    code: 'AM',
    name: 'Armenia',
  },
  {
    code: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'AT',
    name: 'Austria',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    name: 'Belarus',
  },
  {
    code: 'BE',
    name: 'Belgium',
  },
  {
    code: 'BZ',
    name: 'Belize',
  },
  {
    code: 'BJ',
    name: 'Benin',
  },
  {
    code: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'BO',
    name: 'Bolivia',
  },
  {
    code: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BW',
    name: 'Botswana',
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
  },
  {
    code: 'BR',
    name: 'Brazil',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'KH',
    name: 'Cambodia',
  },
  {
    code: 'CM',
    name: 'Cameroon',
  },
  {
    code: 'CA',
    name: 'Canada',
  },
  {
    code: 'CV',
    name: 'Cape Verde',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    code: 'TD',
    name: 'Chad',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CO',
    name: 'Colombia',
  },
  {
    code: 'KM',
    name: 'Comoros',
  },
  {
    code: 'CG',
    name: 'Congo, Republic of the (Brazzaville)',
  },
  {
    code: 'CD',
    name: 'Congo, the Democratic Republic of the (Kinshasa)',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'CI',
    name: "Côte d'Ivoire, Republic of",
  },
  {
    code: 'HR',
    name: 'Croatia',
  },
  {
    code: 'CU',
    name: 'Cuba',
  },
  {
    code: 'CW',
    name: 'Curaçao',
  },
  {
    code: 'CY',
    name: 'Cyprus',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
  },
  {
    code: 'DK',
    name: 'Denmark',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    name: 'Egypt',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'EE',
    name: 'Estonia',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Islas Malvinas)',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
  },
  {
    code: 'FJ',
    name: 'Fiji',
  },
  {
    code: 'FI',
    name: 'Finland',
  },
  {
    code: 'FR',
    name: 'France',
  },
  {
    code: 'GF',
    name: 'French Guiana',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    code: 'TF',
    name: 'French Southern and Antarctic Lands',
  },
  {
    code: 'GA',
    name: 'Gabon',
  },
  {
    code: 'GM',
    name: 'Gambia, The',
  },
  {
    code: 'GE',
    name: 'Georgia',
  },
  {
    code: 'DE',
    name: 'Germany',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    name: 'Greece',
  },
  {
    code: 'GL',
    name: 'Greenland',
  },
  {
    code: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GG',
    name: 'Guernsey',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HT',
    name: 'Haiti',
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City)',
  },
  {
    code: 'HN',
    name: 'Honduras',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'HU',
    name: 'Hungary',
  },
  {
    code: 'IS',
    name: 'Iceland',
  },
  {
    code: 'IN',
    name: 'India',
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    code: 'IQ',
    name: 'Iraq',
  },
  {
    code: 'IE',
    name: 'Ireland',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'IT',
    name: 'Italy',
  },
  {
    code: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JP',
    name: 'Japan',
  },
  {
    code: 'JE',
    name: 'Jersey',
  },
  {
    code: 'JO',
    name: 'Jordan',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    code: 'KE',
    name: 'Kenya',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
  },
  {
    code: 'XK',
    name: 'Kosovo',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    code: 'LA',
    name: 'Laos',
  },
  {
    code: 'LV',
    name: 'Latvia',
  },
  {
    code: 'LB',
    name: 'Lebanon',
  },
  {
    code: 'LS',
    name: 'Lesotho',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LY',
    name: 'Libya',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    name: 'Lithuania',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    name: 'Macedonia, Republic of',
  },
  {
    code: 'MG',
    name: 'Madagascar',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MV',
    name: 'Maldives',
  },
  {
    code: 'ML',
    name: 'Mali',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
  },
  {
    code: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'MR',
    name: 'Mauritania',
  },
  {
    code: 'MU',
    name: 'Mauritius',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'MX',
    name: 'Mexico',
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    code: 'MD',
    name: 'Moldova',
  },
  {
    code: 'MC',
    name: 'Monaco',
  },
  {
    code: 'MN',
    name: 'Mongolia',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MA',
    name: 'Morocco',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    code: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'NA',
    name: 'Namibia',
  },
  {
    code: 'NR',
    name: 'Nauru',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NL',
    name: 'Netherlands',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    name: 'Niger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NU',
    name: 'Niue',
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    code: 'NO',
    name: 'Norway',
  },
  {
    code: 'OM',
    name: 'Oman',
  },
  {
    code: 'PK',
    name: 'Pakistan',
  },
  {
    code: 'PW',
    name: 'Palau',
  },
  {
    code: 'PS',
    name: 'Palestine, State of',
  },
  {
    code: 'PA',
    name: 'Panama',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'PE',
    name: 'Peru',
  },
  {
    code: 'PH',
    name: 'Philippines',
  },
  {
    code: 'PN',
    name: 'Pitcairn',
  },
  {
    code: 'PL',
    name: 'Poland',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    name: 'Qatar',
  },
  {
    code: 'RE',
    name: 'Réunion',
  },
  {
    code: 'RO',
    name: 'Romania',
  },
  {
    code: 'RU',
    name: 'Russian Federation',
  },
  {
    code: 'RW',
    name: 'Rwanda',
  },
  {
    code: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'MF',
    name: 'Saint Martin',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'RS',
    name: 'Serbia',
  },
  {
    code: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SK',
    name: 'Slovakia',
  },
  {
    code: 'SI',
    name: 'Slovenia',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    name: 'South Africa',
  },
  {
    code: 'GS',
    name: 'South Georgia and South Sandwich Islands',
  },
  {
    code: 'SS',
    name: 'South Sudan',
  },
  {
    code: 'ES',
    name: 'Spain',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'SD',
    name: 'Sudan',
  },
  {
    code: 'SR',
    name: 'Suriname',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    code: 'SE',
    name: 'Sweden',
  },
  {
    code: 'CH',
    name: 'Switzerland',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    code: 'TW',
    name: 'Taiwan',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    code: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TK',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TN',
    name: 'Tunisia',
  },
  {
    code: 'TR',
    name: 'Turkey',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UA',
    name: 'Ukraine',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'US',
    name: 'United States',
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'VE',
    name: 'Venezuela, Bolivarian Republic of',
  },
  {
    code: 'VN',
    name: 'Vietnam',
  },
  {
    code: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    code: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
  },
  {
    code: 'YE',
    name: 'Yemen',
  },
  {
    code: 'ZM',
    name: 'Zambia',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
  },
];

export const getHealthGoals = [
  { label: 'All health goals', value: 'all' },
  { label: 'Manage weight', value: 'lose-weight' },
  { label: 'Manage physical pain', value: 'physical-pain' },
  { label: 'Get fitter', value: 'get-fitter' },
  { label: 'Improve my energy and vitality', value: 'improve-general-health' },
  { label: 'Handle stress and burnout', value: 'stress-burnout' },
  { label: 'Manage depression and anxiety', value: 'depression-anxiety' },
  { label: 'Build mental fitness and resilience', value: 'mental-fitness-resilience' },
  { label: 'Improve sleep and relaxation', value: 'sleep-relaxation' },
  { label: 'Manage Diabetes', value: 'manage-diabetes' },
  { label: 'Manage Kidney disease', value: 'kidney' },
  { label: 'Manage High Cholesterol', value: 'recover-heart-illness-or-stroke' },
  { label: 'Manage Heart Disease', value: 'recover-heart-illness-or-stroke' },
  { label: 'Manage Hypertension or Stroke', value: 'recover-heart-illness-or-stroke' },
  { label: 'Manage Cancer', value: 'cope-with-cancer' },
  { label: 'Become a caregiver or empathetic colleague', value: 'be-a-caregiver' },
  { label: 'Perform better at work or sports', value: 'perform-better' },
  { label: 'Build a new healthy habit', value: 'healthy-habits' },
  { label: 'Stop smoking', value: 'smoking-or-addiction' },
];

export const coachSlackList = [
  'hanani@naluri.life',
  'faeza@naluri.life',
  'shawn@naluri.life',
  'seowwei@naluri.life',
  'leikheng@naluri.life',
  'nidaa@naluri.life',
  'serchyi@naluri.life',
  'hafidz+1@naluri.life',
  'nunu@naluri.life',
  'melati@naluri.life',
  'tien@naluri.life',
  'aimi@naluri.life',
  'risa@naluri.life',
  'farah@naluri.life',
  'felicity@naluri.life',
  'michelle@naluri.life',
  'okta+1@naluri.life',
  'amandaxavier@naluri.life',
  'annabelle@naluri.life',
  'hidayah@naluri.life',
  'farahana.sidek+1@naluri.life',
  'rekha@naluri.life',
  'pitcha@naluri.life',
  'maxima@naluri.life',
  'expert@naluri.net',
  'frances@naluri.life',
  'pamilia@naluri.life',
  'darlina@naluri.life',
  'szejin@naluri.life',
  'sharifahamirah@naluri.life',
  'david@naluri.life',
  'hanin.noori@naluri.life',
  'ellisha@naluri.life',
  'jerrick+1@naluri.life',
  'arienda+1@naluri.life',
  'farhaana@naluri.life',
  'nisa@naluri.life',
  'nicole.tan@naluri.life',
  'amanda@naluri.life',
  'hilmika@naluri.life',
  'audy@naluri.life',
  'francisllenado+1@naluri.life',
  'xiuli@naluri.life',
  'erica@naluri.life',
  'kelly@naluri.life',
  'angel+1@naluri.life',
  'chloe.glieowong@naluri.life',
  'fazilah@naluri.life',
  'fateenrosli+1@naluri.life',
  'kevinquibranza@naluri.life',
  'jennifer@naluri.life',
  'lavinia@naluri.life',
  'amni@naluri.life',
  'peiru+1@naluri.life',
  'drjoyoki@naluri.life',
  'nursyahirah@naluri.life',
  'zul.aidi@naluri.life',
  'drshah@naluri.life',
  'jeanne.ooi@naluri.life',
  'maresa.ng@naluri.life',
  'eelin.tan@naluri.life',
  'stephen.yong@naluri.life',
  'rozitah@naluri.life',
  'chase@naluri.life',
  'jasmine@naluri.life',
  'sharon@naluri.life',
  'kian.ng@naluri.life',
  'diana@naluri.life',
  'mind.tanaphong@naluri.life',
  'azman+1@naluri.life',
  'drcaylie@naluri.life',
  'farhana@naluri.life',
  'zeth@naluri.life',
  'kim.thosapit@naluri.life',
  'drandrea@naluri.life',
  'eyvonne@naluri.life',
  'phet@naluri.life',
  'dennis.sugiarto@naluri.life',
  'zaryl@naluri.life',
  'aiman@naluri.life',
  'douglas@naluri.life',
  'jonathan@naluri.life',
  'dhanya@naluri.life',
  'arfah@naluri.life',
  'zulaikha@naluri.life',
  'shasi+1@naluri.life',
  'tiffanie@naluri.life',
  'nattaworn@naluri.life',
  'hidayah.sallehudin@naluri.life',
  'jerome@naluri.life',
  'bonnie@naluri.life',
  'north@naluri.life',
  'drputerihayati@naluri.life',
  'aminah.kamarudin@naluri.life',
  'david.tan@naluri.life',
  'lisa.yuliawati@naluri.life',
  'arifbudi@naluri.life',
  'kexin@naluri.life',
  'aura@naluri.life',
  'angelicadawn@naluri.life',
  'filzaizzyan@naluri.life',
  'rhuyie@naluri.life',
  'jadechuan@naluri.life',
  'janiceng@naluri.life',
  'joyen@naluri.life',
  'huiyin@naluri.life',
  'clara@naluri.life',
  'kahyen@naluri.life',
  'rafael@naluri.life',
  'duy@naluri.life',
  'bunna@naluri.life',
  'chris@naluri.life',
  'nara@naluri.life',
  'fatimah@naluri.life',
  'kellyching@naluri.life',
  'wesley@naluri.life',
  'regina@naluri.life',
  'icel@naluri.life',
  'albert@naluri.life',
  'ivony@naluri.life',
  'qisthi@naluri.life',
  'kyu@naluri.life',
  'phone@naluri.life',
  'clarissa@naluri.life',
  'afnisya@naluri.life',
  'salma@naluri.life',
  'kk@naluri.life',
  'payood@naluri.life',
  'aikabuenavistamd@gmail.com',
  'amandaquah@naluri.life',
  'natashailyas@naluri.life',
  'maygin@naluri.life',
  'laisheon@naluri.life',
  'sandra@naluri.life',
  'sherllie@naluri.life',
  'daniel@naluri.life',
  'denniskananda@naluri.life',
  'grace@naluri.life',
  'catherine@naluri.life',
  'jasminbegam@naluri.life',
  'audrey@naluri.life',
  'cathyluk@naluri.life',
];

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const titleCase = s =>
  // Convert kebab/snake case to title case
  s
    .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
    .replace(/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()); // First char after each -/_



// WEBPACK FOOTER //
// ./src/common/utils.js